import type {
  IAccountContractHistory,
  IAccountServiceHistory,
  IAccountTPV,
  IBillImage,
} from "@apis/accounts/types"
import { Button } from "@components/ui/button"
import type { ColumnDef } from "@tanstack/react-table"
import { DateCell } from "@utils/table/columnFactories"
import { SquareArrowOutUpRight } from "lucide-react"
import { Link } from "react-router"

export const accountTPVsColumns: ColumnDef<IAccountTPV>[] = [
  {
    accessorKey: "tpv_vendor",
    header: "TPV Vendor",
  },
  {
    accessorKey: "tpv_type",
    header: "Type",
  },
  {
    accessorKey: "order_dt",
    header: "Order Date",
    cell: (props) => <DateCell {...props} />,
  },
  {
    accessorKey: "recorded_dt",
    header: "Recorded Date",
    cell: (props) => <DateCell {...props} />,
  },
  {
    accessorKey: "tpv_url",
    header: "File",
    cell: ({ row }) => {
      const rowData = row.original

      if (!rowData.tpv_url) return
      return (
        <Button variant="link" asChild>
          <Link
            to={rowData.tpv_url}
            download
            target="_blank"
            rel="noopener noreferrer"
          >
            View/Play
          </Link>
        </Button>
      )
    },
  },
]

export const accountContractHistoriesColumns: ColumnDef<IAccountContractHistory>[] =
  [
    {
      accessorKey: "plan_name",
      header: "Plan Name",
    },
    {
      accessorKey: "rate_friendly",
      header: "Rate",
    },
    {
      accessorKey: "contract_start_dt",
      header: "From Date",
      cell: (props) => <DateCell {...props} />,
    },
    {
      accessorKey: "contract_end_dt",
      header: "To Date",
      cell: (props) => <DateCell {...props} />,
    },
  ]

export const accountBillImagesColumns: ColumnDef<IBillImage>[] = [
  {
    id: "image_url",
    header: "Bill Image Url",
    cell: ({ row }) => {
      const rowData = row.original
      return (
        <Link to={rowData.image_url} className="tw:text-primary">
          View
          <SquareArrowOutUpRight size={24} className="tw:inline-block tw:p-1" />
        </Link>
      )
    },
  },
  {
    accessorKey: "created_at",
    header: "Created Date",
    cell: (props) => <DateCell {...props} />,
  },
]

export const accountServiceHistoriesColumns: ColumnDef<IAccountServiceHistory>[] =
  [
    {
      accessorKey: "from_dt",
      header: "From Date",
      cell: (props) => <DateCell {...props} />,
    },
    {
      accessorKey: "to_dt",
      header: "To Date",
      cell: (props) => <DateCell {...props} />,
    },
    {
      accessorKey: "reason",
      header: "Reason",
    },
  ]
